// extracted by mini-css-extract-plugin
module.exports = {"section":"DisplayOrderSection_section__1jFCb","subSection":"DisplayOrderSection_subSection__3Vgx1"};